interface Props {
  on: boolean;
  onToggle: () => void;
}

export function Theme90sToggle({ on, onToggle }: Props) {
  if (on) {
    return (
      <button
        className="theme-toggle-90s theme-90s-ornament"
        onClick={onToggle}
        title="Return to 2026"
      >
        <span style={{ fontSize: 16 }}>🚀</span>
        <span>RETURN TO 2026</span>
      </button>
    );
  }

  return (
    <button
      className="theme-toggle theme-toggle-modern"
      onClick={onToggle}
      title="Time travel to 1997"
    >
      <span style={{ fontSize: 14 }}>✨</span>
      <span>90s Mode</span>
    </button>
  );
}
